export default __webpack_public_path__ + "static/10_immergas-b0f34573f07367f0b4890a33dab568cb.png";